import React from 'react'
import { Row, Col } from 'react-bootstrap'
import DocumentTitle from 'react-document-title'
import Backdrop from '_/shared/components/backdrop'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Input from '_/shared/components/input'
import getGravatarUrl from '_/utils/getGravatarUrl'

/**
 * My account page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class SwitchPlan extends React.Component {
  static propTypes = {
    account: React.PropTypes.object,
    groups: React.PropTypes.object
  }

  static contextTypes = {
    router: React.PropTypes.func,
    store: React.PropTypes.object
  }

  static fetchData (store, params) {
    return {
      groups: store.get('/groups')
    }
  }

  constructor (props, context) {
    super(props, context)
    this.state = {
      isDisabled: false
    }
  }

  async handleGroup(group, evt) {
    evt.preventDefault()
    const { store } = this.context

    this.setState({isDisabled: true})

    try {
      await store.post('/account', { group })
      location.reload()
    } catch (er) {
      console.error(er)
    }
  }

  render() {
    const { groups, account } = this.props
    const { isDisabled } = this.state

    const backdropPhoto = getGravatarUrl(account.get('email'), 800)
    const photo = getGravatarUrl(account.get('email'), 600)

    return (
      <DocumentTitle title="My account">
        <Backdrop url={backdropPhoto}>
          <h3>My account</h3>
          <form>
            <Row>
              <Col xs={6}>
                <h4>Click a plan to switch to</h4>
                <ul>
                {groups.get('data').map((group, key) => (
                  <Input
                    key={key}
                    type="checkbox"
                    disabled={isDisabled}
                    label={group.get('name')}
                    checked={account.getIn(['group', 'id']) === group.get('id')}
                    onChange={this.handleGroup.bind(this, group)}
                  />
                ))}
                </ul>
                <h4>Want or need more? <a href="/signup">Create new plan</a></h4>
                <p><a href="mailto:info@redicomps.com">Contact us</a> (800-574-9185) for multi-plan discounts.</p>
              </Col>
              <Col xs={6}>
                <p className="text-center text-muted">
                  <img className="img-circle" src={photo} style={{ width: 300 }}/>
                  <br/><br/>
                  Profile pictures are generated using your email address from gravatar.com.  Update your picture <a href="http://en.gravatar.com/emails/">here</a>.
                </p>
              </Col>
            </Row>
          </form>
        </Backdrop>
      </DocumentTitle>
    )
  }
}

export default SwitchPlan



// WEBPACK FOOTER //
// ./modules/shared/pages/account/switchPlan.js